/* SpawnAnything — replay recorder (main thread, pure: no DOM, testable in Node).
   main.js reports every setup message it sends to the sim worker and forwards the worker's 'cmdlog' messages
   (commands with the tick they were applied at, state hashes) and frames (current tick). Older replays also carry
   'speed' entries (tick length before the constant tick of feature:slowmo); the worker still plays them.
   build() turns that into a replay object (see format.js). */
import { REPLAY_VERSION } from './format.js';

export function createRecorder() {
  let sim = null, scene = null, seed = 0, title = '', terrainSpec = null;
  let cmds = [], hashes = [], tick = 0, overAt = 0;

  return {
    /** a setup message went to the worker: a new battle (the last one before the start counts) */
    setup(msg, sceneInfo, matchTitle) {
      const { cmd, gen, terrain, quiet, keepReplay, ...rest } = msg;
      if (rest.terrainSpec) terrainSpec = rest.terrainSpec;           // the worker keeps the last terrain
      sim = structuredClone({ ...rest, terrainSpec: rest.terrainSpec || terrainSpec || { preset: 'flach', seed: 0 } });
      seed = msg.seed >>> 0; scene = sceneInfo || null; title = matchTitle || '';
      cmds = []; hashes = []; tick = 0; overAt = 0;
    },
    /** worker 'cmdlog': flat [tick, cmd, tick, cmd, …] */
    log(flat) {
      for (let j = 0; j + 1 < flat.length; j += 2) {
        const k = flat[j], c = flat[j + 1];
        if (c && c.cmd === 'hash') { if (!hashes.length || hashes[hashes.length - 1][0] < k) hashes.push([k, c.h >>> 0]); }
        else cmds.push([k, c]);
      }
    },
    /** worker frame: m.step = ticks simulated so far */
    frame(m) { if (m.step > tick) tick = m.step; if (m.over && !overAt && m.step > 0) overAt = m.step; },
    get ticks() { return tick; },
    get ready() { return !!sim && tick > 0; },
    get title() { return title; },
    /** tick at which the battle was decided (0 = still running) */
    get overAt() { return overAt; },
    /** replay object for ticks 1..upTo (default: everything so far, but at most 3 s past the end of the battle) */
    build(upTo = overAt ? Math.min(tick, overAt + 90) : tick) {
      if (!sim) return null;
      const end = Math.min(upTo, tick);
      return {
        v: REPLAY_VERSION, app: 'spawnanything', created: new Date().toISOString(), title, ticks: end, seed,
        sim: structuredClone(sim), scene: scene ? JSON.parse(JSON.stringify(scene)) : null,
        cmds: cmds.filter(e => e[0] <= end).map(([k, c]) => [k, { ...c }]),
        hashes: hashes.filter(e => e[0] <= end).map(e => e.slice()),
      };
    },
  };
}
